/* eslint-disable new-cap */
import Loadable from 'react-loadable';

import CanRoute from '../components/RouteWrappers/CanRoute';
import Loader from './Loader';

export const prefix = '/academy';
export const adminPrefix = '/academy/admin';

/**
 * Route subjects
 * @readonly
 * @enum {string}
 */
const subject = {
  questionnaire: 'questionnaire',
  positioning_questionnaire: 'positioning-questionnaire',
  sessions: 'sessions',
  trainers: 'trainers',
  trainings: 'trainings',
  trainingSites: 'training-sites',
};

/**
 * Route actions
 * @readonly
 * @enum {string}
 */
const action = {
  create: 'create',
  payment: 'payment',
};

const Dashboard = Loadable({
  loader: () => import('../views/Academy/DashboardUser'),
  loading: Loader,
});

const DashboardAdmin = Loadable({
  loader: () => import('../views/Academy/DashboardAdmin'),
  loading: Loader,
});

const TrainingHistory = Loadable({
  loader: () => import('../views/Academy/TrainingHistory'),
  loading: Loader,
});

const TrainingTrainerHistory = Loadable({
  loader: () => import('../views/Academy/TrainingTrainerHistory'),
  loading: Loader,
});

const SessionEdit = Loadable({
  loader: () => import('../views/Academy/SessionEdit'),
  loading: Loader,
});
const SessionShow = Loadable({
  loader: () => import('../views/Academy/SessionShow'),
  loading: Loader,
});

const SessionCreate = Loadable({
  loader: () => import('../views/Academy/SessionCreate'),
  loading: Loader,
});

const SessionQuestionnaire = Loadable({
  loader: () => import('../views/Academy/SessionQuestionnaire'),
  loading: Loader,
});

const SessionPayment = Loadable({
  loader: () => import('../views/Academy/SessionPayment'),
  loading: Loader,
});

const SessionList = Loadable({
  loader: () => import('../views/Academy/SessionList'),
  loading: Loader,
});

const TrainerCreate = Loadable({
  loader: () => import('../views/Academy/TrainerCreate'),
  loading: Loader,
});

const TrainerEdit = Loadable({
  loader: () => import('../views/Academy/TrainerEdit'),
  loading: Loader,
});

const TrainerList = Loadable({
  loader: () => import('../views/Academy/TrainerList'),
  loading: Loader,
});

const TrainingCreate = Loadable({
  loader: () => import('../views/Academy/TrainingCreate'),
  loading: Loader,
});

const TrainingEdit = Loadable({
  loader: () => import('../views/Academy/TrainingEdit'),
  loading: Loader,
});

const TrainingShow = Loadable({
  loader: () => import('../views/Academy/TrainingShow'),
  loading: Loader,
});

const TrainingList = Loadable({
  loader: () => import('../views/Academy/TrainingList'),
  loading: Loader,
});

const TrainingQuestionnaireEdit = Loadable({
  loader: () => import('../views/Academy/TrainingQuestionnaireEdit'),
  loading: Loader,
});

const TrainingPositioningQuestionnaireEdit = Loadable({
  loader: () => import('../views/Academy/TrainingPositioningQuestionnaireEdit'),
  loading: Loader,
});

const TrainingSiteCreate = Loadable({
  loader: () => import('../views/Academy/TrainingSiteCreate'),
  loading: Loader,
});

const TrainingSiteEdit = Loadable({
  loader: () => import('../views/Academy/TrainingSiteEdit'),
  loading: Loader,
});

const TrainingSiteList = Loadable({
  loader: () => import('../views/Academy/TrainingSiteList'),
  loading: Loader,
});

const StatisticsTrainingAdmin = Loadable({
  loader: () => import('../views/Academy/DataTableTraining'),
  loading: Loader,
});

const StatisticsSessionAdmin = Loadable({
  loader: () => import('../views/Academy/DataTableSession'),
  loading: Loader,
});

const StatisticsParticipantAdmin = Loadable({
  loader: () => import('../views/Academy/DataTableParticipant'),
  loading: Loader,
});

const StatisticsTrainerAdmin = Loadable({
  loader: () => import('../views/Academy/DataTableTrainer'),
  loading: Loader,
});

const academyAdminRoutes = [
  {
    path: `${adminPrefix}/dashboard`,
    name: 'Dashboard admin de DigitRe Académie',
    component: DashboardAdmin,
  },
  {
    path: `${adminPrefix}/${subject.sessions}/${action.create}`,
    name: "Création d'une session",
    component: SessionCreate,
  },
  {
    path: `${adminPrefix}/${subject.sessions}/:id`,
    name: "Édition d'une session",
    component: SessionEdit,
  },
  {
    path: `${adminPrefix}/${subject.sessions}`,
    name: 'Liste des sessions',
    component: SessionList,
  },
  {
    path: `${adminPrefix}/${subject.trainers}/${action.create}`,
    name: "Création d'un formateur",
    component: TrainerCreate,
  },
  {
    path: `${adminPrefix}/${subject.trainers}/:id`,
    name: "Édition d'une formateur",
    component: TrainerEdit,
  },
  {
    path: `${adminPrefix}/${subject.trainers}`,
    name: 'Liste des formateurs',
    component: TrainerList,
  },
  {
    path: `${adminPrefix}/${subject.trainings}/${action.create}`,
    name: "Création d'une formation",
    component: TrainingCreate,
  },
  {
    path: `${adminPrefix}/${subject.trainings}/:id/${subject.questionnaire}`,
    name: "Édition du questionnaire d'une formation",
    component: TrainingQuestionnaireEdit,
  },
  {
    path: `${adminPrefix}/${subject.trainings}/:id/${subject.positioning_questionnaire}`,
    name: "Édition du questionnaire de positionnement d'une formation",
    component: TrainingPositioningQuestionnaireEdit,
  },
  {
    path: `${adminPrefix}/${subject.trainings}/:id`,
    name: "Édition d'une formation",
    component: TrainingEdit,
  },
  {
    path: `${adminPrefix}/${subject.trainings}`,
    name: 'Liste des formations',
    component: TrainingList,
  },
  {
    path: `${adminPrefix}/${subject.trainingSites}/${action.create}`,
    name: "Création d'un lieu de formation",
    component: TrainingSiteCreate,
  },
  {
    path: `${adminPrefix}/${subject.trainingSites}/:id`,
    name: "Édition d'un lieu de formation",
    component: TrainingSiteEdit,
  },
  {
    path: `${adminPrefix}/${subject.trainingSites}`,
    name: 'Liste des lieux de formation',
    component: TrainingSiteList,
  },
  {
    path: `${adminPrefix}/statistics/trainings`,
    name: 'Formations de DigitRe Académie',
    component: StatisticsTrainingAdmin,
  },
  {
    path: `${adminPrefix}/statistics/sessions`,
    name: 'Sessions de DigitRe Académie',
    component: StatisticsSessionAdmin,
  },
  {
    path: `${adminPrefix}/statistics/participants`,
    name: 'Participants de DigitRe Académie',
    component: StatisticsParticipantAdmin,
  },
  {
    path: `${adminPrefix}/statistics/trainers`,
    name: 'Formateurs de DigitRe Académie',
    component: StatisticsTrainerAdmin,
  },
];

const academyRoutes = [
  {
    path: `${prefix}/dashboard`,
    name: 'Dashboard de DigitRe Académie',
    component: Dashboard,
  },
  {
    path: `${prefix}/trainings-history`,
    name: "Historique de l'utilisateur",
    component: TrainingHistory,
  },
  {
    path: `${prefix}/trainings-trainer-history`,
    name: 'Historique du formateur',
    component: TrainingTrainerHistory,
  },
  {
    path: `${prefix}/${subject.sessions}/:id/${action.payment}`,
    name: "Paiement d'une session",
    component: SessionPayment,
  },
  {
    path: `${prefix}/${subject.sessions}/:id/${subject.questionnaire}/:questionnaire_code`,
    name: 'Questionnaire de session',
    component: SessionQuestionnaire,
  },
  {
    path: `${prefix}/${subject.sessions}/:id`,
    name: "Vue d'une session",
    component: SessionShow,
  },
  {
    path: `${prefix}/${subject.trainings}/:id`,
    name: "Vue d'une formation",
    component: TrainingShow,
  },
  {
    path: `${prefix}/${subject.trainings}`,
    name: 'Liste des formations',
    component: TrainingList,
  },
];

export default [
  ...academyAdminRoutes.map(route => ({
    wrapper: CanRoute,
    wrapperArgs: { rule: 'admin', subject: 'digitreAcademie' },
    ...route,
  })),
  ...academyRoutes.map(route => ({
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'digitreAcademie' },
    ...route,
  })),
];
